var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCoin1 = function SvgIconCoin1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.683 13.761c-1.02 3.748-4.84 5.997-8.53 5.024-3.691-.973-5.856-4.8-4.836-8.548 1.02-3.748 4.84-5.997 8.53-5.023 3.691.973 5.856 4.8 4.836 8.547Z",
    fill: "#FFCF23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.624 14.274c-1.304 4.79-6.208 7.715-11 6.452-4.792-1.264-7.552-6.21-6.248-11 1.304-4.79 6.208-7.715 11-6.452 4.792 1.264 7.552 6.21 6.248 11Zm-10.471 4.512c3.69.973 7.51-1.276 8.53-5.024 1.02-3.747-1.145-7.574-4.835-8.548-3.691-.973-7.51 1.276-8.531 5.024-1.02 3.747 1.145 7.574 4.835 8.548Z",
    fill: "#E59722"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.389 13.42c-.83 3.044-3.915 4.877-6.892 4.092-2.976-.784-4.717-3.888-3.888-6.933.83-3.045 3.915-4.877 6.892-4.093 2.977.785 4.717 3.889 3.888 6.934Z",
    fill: "#FFCF23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.33 13.932c-1.11 4.073-5.27 6.599-9.361 5.52-4.092-1.078-6.41-5.311-5.301-9.384 1.11-4.074 5.27-6.6 9.362-5.522 4.09 1.079 6.41 5.312 5.3 9.386Zm-8.833 3.58c2.977.785 6.062-1.047 6.892-4.092.83-3.045-.911-6.149-3.888-6.933-2.977-.785-6.062 1.047-6.892 4.092-.829 3.045.912 6.15 3.888 6.934Z",
    fill: "#E59722"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.23 10.724c-.274-.934-1.168-1.62-2.23-1.62h-.004c-.93 0-1.733.528-2.1 1.288h.003c-.138.284-.215.6-.215.933 0 1.227 1.037 2.22 2.316 2.22 0 0-.367 1.27-1.17 1.928 0 0 2.92-1.076 3.438-3.656.029-.143.048-.346.048-.492 0-.208-.03-.41-.087-.6Z",
    fill: "#E59722"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.137 8.083a5.41 5.41 0 0 0-2.19-1.16c-2.976-.785-6.061 1.048-6.89 4.092-.537 1.968 0 3.96 1.25 5.336-1.562-1.367-2.293-3.585-1.697-5.773.83-3.045 3.915-4.877 6.891-4.093a5.412 5.412 0 0 1 2.636 1.598Z",
    fill: "#FFDD65"
  })));
};
export default SvgIconCoin1;